import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { TextInput } from 'packages/common-frontend/components/InputsBETA/TextInput';
import {
  GetUploadedDocumentsDocumentGQLType,
  useUpdateDocumentNameMutation,
} from '~/packages/credit-facility/requests/requests.gql.generated';

type FormData = {
  documentName: string;
};

export const ConfirmRenameDocumentModal = ({
  isOpen,
  onClose,
  documentName,
  documentId,
}: {
  isOpen: boolean;
  onClose: () => void;
  documentName: string;
  documentId: string;
}) => {
  const [updateDocumentName] = useUpdateDocumentNameMutation({
    refetchQueries: [GetUploadedDocumentsDocumentGQLType],
  });

  const form = useForm<FormData>({
    defaultValues: {
      documentName,
    },
    mode: 'onSubmit',
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <FormProvider {...form}>
          <form
            onSubmit={form.handleSubmit(async (formData) => {
              await updateDocumentName({
                variables: {
                  documentId,
                  newDocumentName: formData.documentName,
                },
              });
              onClose();
            })}
          >
            <ModalHeader>Rename document</ModalHeader>
            <ModalBody>
              <TextInput<FormData>
                name="documentName"
                label="Document name"
                placeholder="Enter new document name"
                required
              />
            </ModalBody>

            <ModalFooter>
              <Button
                onClick={() => {
                  form.reset({ documentName });
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button type="submit" colorScheme="v2-aurora" ml={3}>
                Save
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  );
};
